import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { PageWrapper } from '../solceller';

import { VentilasjonsForm } from './form';

export const Ventilasjon = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <Heading data-size="lg" level={2}>
        {t('register.ventilation.header')}
      </Heading>
      <Paragraph>{t('register.ventilation.description')}</Paragraph>
      <VentilasjonsForm />
    </PageWrapper>
  );
};
